const TEMP_FAVORITES_KEY = 'easybail_temp_favorites'

function readIds(): string[] {
  try {
    const raw = localStorage.getItem(TEMP_FAVORITES_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return []
    return parsed.map(String).filter(Boolean)
  } catch {
    return []
  }
}

function writeIds(ids: string[]): void {
  try {
    localStorage.setItem(TEMP_FAVORITES_KEY, JSON.stringify(ids.slice(0, 100)))
  } catch {
    // Ignore quota / private mode.
  }
}

export function getTempFavoriteIds(): string[] {
  return readIds()
}

export function isTempFavorite(propertyId: string): boolean {
  return readIds().includes(String(propertyId))
}

export function addTempFavorite(propertyId: string): void {
  const id = String(propertyId)
  const next = readIds().filter(item => item !== id)
  next.unshift(id)
  writeIds(next)
}

export function removeTempFavorite(propertyId: string): void {
  const id = String(propertyId)
  writeIds(readIds().filter(item => item !== id))
}

export function toggleTempFavorite(propertyId: string): boolean {
  const id = String(propertyId)
  if (readIds().includes(id)) {
    removeTempFavorite(id)
    return false
  }
  addTempFavorite(id)
  return true
}

/** Returns pending ids and clears storage (for post-login sync). */
export function consumeTempFavorites(): string[] {
  const ids = readIds()
  try {
    localStorage.removeItem(TEMP_FAVORITES_KEY)
  } catch {
    // ignore
  }
  return ids
}
